/* eslint-disable react/prop-types */
import * as React from 'react';
import {Context} from '../../../../context/dataStore';
import './MajorSearch.scss';
import {mapToDisplay} from '../util';

const MajorSearch = props => {
  const {setSearchKeyWord, setSearchResult, setAccordionData, setIsDisable, org_id, updateAllToListFlag, readOnly} = props;
  const {getMajorsByKeyword, dispatch} = React.useContext(Context);

  const [searchEnable, setSearchEnable] = React.useState(false);
  const [value, setValue] = React.useState('');

  const isNumeric = num => !isNaN(num) && !isNaN(parseInt(num));

  const search = async () => {
    const res = await getMajorsByKeyword(org_id, value);
    //const res= require('../sample.json');
    const rtnData = mapToDisplay(res);
    setSearchResult(rtnData);
  };
  // console.log({searchTerm, value})
  const onInput = entry => {
    entry = entry.trim();
    if(entry.length < 3) {
      setSearchEnable(false);
    } else{
      if (entry.length === 2) {
        if(isNumeric(entry)) {
          setSearchEnable(true);
        }else{
          setSearchEnable(false);
        }
      } else{
        setSearchEnable(true);
      }
    }
  };

  const clearInput = () => {
    setValue('');
    setSearchKeyWord('');
    setSearchEnable(false);
  };

  return (
    <div className='searchbar'>
      <div className='flex_container_col cb-input'>
        <input
          autoComplete='off'
          type='text' id='majorSearchInput'
          placeholder='Search by keyword or CIP code'
          aria-label='major look up'
          data-testid='majorlookuptestid'
          value={value}
          disabled={readOnly}
          aria-readonly={readOnly}
          onChange={event => {
            const val = event.target.value;
            setValue(val);
            setSearchKeyWord(val);
            onInput(val);
          }}
        />
        <i className='cb-icon cb-search' aria-hidden='true' id='searchIcon' />
        <i className='cb-icon cb-x-mark' aria-hidden='true' id='closeX' onClick={() => clearInput()} />
      </div>
      <button type='button'
        className='cb-btn cb-btn-light-xs cb-btn-black searchBtn'
        disabled={searchEnable===false||readOnly}
        aria-readonly={searchEnable===false||readOnly}
        onClick={() => {
          search();
          setAccordionData([]);
          setIsDisable(false);
          updateAllToListFlag(false);
          dispatch({type:'UPDATE_SEARCH_TERM', payload: value});
        }}
      >Search</button>
    </div>
  );
};

export default MajorSearch;